import * as Factory from 'factory.ts'
import faker from 'faker'

import { type EntitySyncConfigurationConstructor } from '../entitySyncConfiguration'

export const EntitySyncConfigurationConstructorFactory =
  Factory.Sync.makeFactory<EntitySyncConfigurationConstructor>({
    id: Factory.each(() => faker.random.uuid()),
    entity: 'urn:integration:local-entity:vendor',
    isEnabled: true,
    lastSync: Factory.each(() => faker.date.past().toISOString()),
  })
